import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { useEffect, useState } from "react";
import FileResizer from "react-image-file-resizer";
import { db, storage } from "../firebaseConfig";
import { addDoc, collection, deleteDoc, getDocs } from "firebase/firestore";
import logo40px from "../res/Logo/logo40px.png";
import { doc } from "firebase/firestore";

function FeaturedAdmin() {
  const featuresRef = collection(db, "features");
  const [addIsActive, setAddIsActive] = useState(true);
  const [editIsActive, setEditIsActive] = useState(false);
  const [saveIsActive, setSaveIsActive] = useState(false);
  const [delIsActive, setDelIsActive] = useState(false);
  const [cancelIsActive, setCancelIsActive] = useState(false);
  const [formIsActive, setFormIsActive] = useState(false);
  const [activeFeature, setActiveFeature] = useState("");
  const [titleInput, setTitleInput] = useState("");
  const [dateInput, setDateInput] = useState("");
  const [bodyInput, setBodyInput] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [imgInput, setImgInput] = useState("");
  const [newOrEdit, setNewOrEdit] = useState(0);
  const [features, setFeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [imgFileName, setImgFileName] = useState("");
  const [imgUrlInput, setImgUrlInput] = useState("");

  const getFeatures = async () => {
    const data = await getDocs(featuresRef);
    //console.log(data.docs);
    setFeatures(
      data.docs
        .map((doc) => ({ ...doc.data(), id: doc.id }))
        .sort((a, b) => {
          let da = new Date(a.date);
          let db = new Date(b.date);
          return db - da;
        }),
    );
  };

  useEffect(() => {
    getFeatures();
    //console.log(features);
  }, []);

  const resizeFile = (file) =>
    new Promise((resolve) => {
      FileResizer.imageFileResizer(
        file,
        1024,
        1024,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file",
      );
    });

  const addNewFeature = async () => {
    setLoading(true);

    await addDoc(
      featuresRef,
      {
        title: titleInput,
        date: dateInput,
        body: bodyInput,
        imgFileName: imgFileName,
        url: titleInput.replaceAll(" ", "-"),
        imgurl: imgUrlInput,
      },
      alert("Added"),
      setAddIsActive(true),
      setSaveIsActive(false),
      setFormIsActive(false),
      setLoading(false),
      getFeatures(),
      //setLoading(false)
    );
  };

  const uploadImage = (file, imgFileName) => {
    if (!file) return;
    const storageRef = ref(storage, `files/images/feature/${imgFileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on("state_changed", (snapshot) => {
      const prog = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
      );
      console.log(prog);
      setUploadProgress(prog);
      if (prog == 100) {
        alert("Upload Succesful!");
        getDownloadURL(snapshot.ref).then((res) => {
          console.log(res);
          setImgUrlInput(res);
        });

        setLoading(false);
      }
    });
  };

  const newFeature = async (imgFile) => {
    setLoading(true);
    let imgFileNameGen = (Math.random() + 1).toString(36).substring(7); //Random string Generator
    const fileName = `${imgFileNameGen}.jpg`;
    //let newFeatureImgRef;

    try {
      const image = await resizeFile(imgFile);
      uploadImage(image, fileName);
      console.log(image);
    } catch (err) {
      console.log(err);
    }
  };

  const editFeature = async (imgFile) => {
    alert("Editing...");
    try {
      //let file = e.target[0].files[0];
      //const image = await resizeFile(file);
    } catch (err) {
      console.log(err);
    }
  };

  const uploadFormHandler = async (e) => {
    e.preventDefault();
    let blankInput = false;

    // Only check input elements that have a name attribute
    const inputs = e.target.querySelectorAll("input, textarea");
    for (let i = 0; i < inputs.length; i++) {
      console.log(inputs[i].value);
      if (!inputs[i].value) {
        blankInput = true;
      }
    }

    if (blankInput) {
      alert("Do not leave any field blank");
      return;
    }

    const imgFile = e.target[1].files[0];
    console.log(imgFile);
    if (e.target[1].files.length === 0) {
      alert("No File Selected");
    } else {
      console.log(activeFeature);
      activeFeature ? alert("Edit Feature Under Maintenance") : addNewFeature();
    }
  };

  const deleteFeature = async () => {
    console.log(activeFeature);
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this?",
    );
    if (confirmDelete === true) {
      if (features.length <= 3) {
        alert("There should atleast be 3 features left");
      } else {
        const featuresDoc = doc(db, "features", activeFeature);
        await deleteDoc(featuresDoc);
        alert("Feature Deleted!");
        await getFeatures();
      }
    }
  };

  const addButtonHandler = () => {
    // Switch from "editing selected feature" to "add new feature".
    // Clear edit state so Save triggers addNewFeature instead of edit-under-maintenance.
    cancelButtonHandler();
    setActiveFeature("");
    setAddIsActive(false);
    setSaveIsActive(true);
    setFormIsActive(true);
    setCancelIsActive(true);
  };

  const cancelButtonHandler = () => {
    setTitleInput("");
    setDateInput("");
    setBodyInput("");
    setImgUrl("");
    setFormIsActive(false);
    setAddIsActive(true);
    setSaveIsActive(false);
    setCancelIsActive(false);
    setEditIsActive(false);
    setDelIsActive(false);
  };

  const editActive = (val) => {
    cancelButtonHandler();
    setTitleInput(val.title);
    setDateInput(val.date);
    setBodyInput(val.body);
    setActiveFeature(val.id);

    // Prefer the already-saved download URL so the preview works
    // even if Storage access/policy changes.
    if (val.imgurl) {
      setImgUrl(val.imgurl);
    } else if (val.imgFileName) {
      // Fallback (only if imgurl is missing):
      const storageRef = ref(
        storage,
        `files/images/feature/${val.imgFileName}`,
      );
      getDownloadURL(storageRef)
        .then((res) => {
          setImgUrl(res);
        })
        .catch(() => {
          // Keep the UI functional even if the fallback fails.
          setImgUrl("");
        });
    }

    setCancelIsActive(true);
    setEditIsActive(true);
    setDelIsActive(true);
  };

  const editButtonHandler = () => {
    setAddIsActive(false);
    setSaveIsActive(true);
    setFormIsActive(true);
    setCancelIsActive(true);
    setDelIsActive(true);
    setEditIsActive(false);
  };

  return (
    <div className="bg-white w-[100%] h-[100%] p-4 rounded-xl shadow-md flex flex-col gap-3 overflow-hidden">
      <div className="border-l-4 border-sky-500 pl-3 flex-shrink-0">
        <h1 className="font-bold text-2xl text-slate-800">Featured News</h1>
        <p className="text-sm text-slate-400">
          Manage the feature items shown on the homepage
        </p>
      </div>

      {/* Equal-width columns on xl+ */}
      <div className="flex-1 min-h-0 grid grid-cols-1 gap-2 xl:grid-cols-2">
        {/* List */}
        <div className="flex flex-col gap-2 min-h-0">
          <div className="border-l-4 border-sky-300 pl-2 flex-shrink-0">
            <h2 className="text-base font-semibold text-slate-700">Features</h2>
          </div>

          <div className="flex flex-row justify-between items-center flex-shrink-0 px-1">
            <span className="text-xs text-slate-400">
              {features.length} item{features.length === 1 ? "" : "s"}
            </span>
            <button
              className="flex items-center gap-1.5 bg-sky-600 hover:bg-sky-700 active:bg-sky-800 text-white text-sm font-semibold rounded-lg py-2 px-4 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={addButtonHandler}
              disabled={!addIsActive}
              type="button"
            >
              <span className="text-lg leading-none">+</span> Add Feature
            </button>
          </div>

          <div className="flex-1 min-h-[200px] h-[calc(50vh-120px)] md:h-[calc(100vh-180px)] rounded overflow-auto border border-slate-200 bg-white">
            {features.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full text-slate-400 gap-2 py-8">
                <svg
                  className="h-10 w-10 opacity-40"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 21h16.5m-12-4.5l2.25-2.25m3.75 2.25L14.25 10.5m3 6.75H6.75"
                  />
                </svg>
                <span className="text-sm">No features found</span>
              </div>
            ) : (
              features.map((val, key) => {
                const isActive = val?.id === activeFeature;
                return (
                  <div
                    className={`flex flex-row gap-3 p-2 mx-1 my-1 rounded-lg cursor-pointer transition-colors border-l-4 ${
                      isActive
                        ? "bg-sky-50 border-sky-500"
                        : "border-transparent hover:bg-sky-50 hover:border-sky-200"
                    }`}
                    key={key}
                    onClick={() => editActive(val)}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="w-10 h-10 shrink-0 rounded-md overflow-hidden bg-stone-100 ring-1 ring-slate-200">
                      {val?.imgurl ? (
                        <img
                          src={val.imgurl}
                          alt=""
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center">
                          <img
                            src={logo40px}
                            alt=""
                            className="w-6 h-6 opacity-60"
                          />
                        </div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3
                        className={`font-bold text-base truncate whitespace-nowrap overflow-hidden text-ellipsis max-w-full ${
                          isActive ? "text-sky-900" : "text-slate-900"
                        }`}
                        title={val?.title}
                      >
                        {val.title}
                      </h3>
                      {val?.date ? (
                        <p className="text-xs text-sky-600 mt-0.5 truncate">
                          {val.date}
                        </p>
                      ) : null}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* Details */}
        <div className="flex flex-col gap-2 min-h-0">
          <div className="border-l-4 border-sky-300 pl-2 flex-shrink-0">
            <h2 className="text-base font-semibold text-slate-700">Details</h2>
          </div>

          <form
            className="flex-1 min-h-0 bg-slate-50 border border-slate-200 rounded-xl p-3 flex flex-col gap-3"
            onSubmit={uploadFormHandler}
          >
            <div className="flex flex-col w-full gap-1">
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                Title
              </label>
              <input
                className="w-full border border-slate-200 bg-white rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:opacity-60 disabled:bg-slate-100"
                type="text"
                disabled={!formIsActive}
                value={titleInput}
                onChange={(e) => setTitleInput(e.target.value)}
              />
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                Feature Image
              </label>
              <div className="w-full h-32 bg-sky-400 rounded-lg overflow-hidden flex items-center justify-center">
                {imgUrl ? (
                  <img
                    className="w-full h-full object-cover"
                    src={imgUrl}
                    alt={titleInput ? `Preview: ${titleInput}` : "Preview"}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-white/90 text-sm">
                    No image selected
                  </div>
                )}
              </div>
              <input
                className="rounded-xl bg-stone-200 w-full disabled:hidden"
                type="file"
                accept="image/jpeg"
                disabled={!formIsActive}
                onChange={(e) => {
                  console.log(e.target.value);
                  console.log(e.target.files[0]);
                  newFeature(e.target.files[0]);
                  setImgUrl(URL.createObjectURL(e.target.files[0]));
                  setImgInput(e.target.value);
                }}
                value={imgInput}
              />
            </div>

            <div className="flex flex-col w-full gap-1">
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                Date
              </label>
              <input
                className="w-full border border-slate-200 bg-white rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:opacity-60 disabled:bg-slate-100"
                type="date"
                disabled={!formIsActive}
                value={dateInput}
                onChange={(e) => setDateInput(e.target.value)}
              />
            </div>

            <div className="flex flex-col w-full gap-1 min-h-0 flex-1">
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                Body
              </label>
              <textarea
                className="resize-none flex-1 min-h-[160px] w-full border border-slate-200 bg-white rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:opacity-60 disabled:bg-slate-100"
                disabled={!formIsActive}
                value={bodyInput}
                onChange={(e) => setBodyInput(e.target.value)}
              />
            </div>

            {/* Sticky actions */}
            <div className="sticky bottom-0 bg-white/90 backdrop-blur border-t border-slate-200 pt-3 flex flex-wrap justify-end gap-2">
              <button
                className="bg-sky-800 hover:bg-sky-900 text-white font-bold rounded-lg py-2 px-4 text-sm disabled:opacity-25 disabled:cursor-not-allowed transition-colors"
                disabled={!editIsActive}
                type="button"
                onClick={editButtonHandler}
              >
                Edit
              </button>
              <button
                className="bg-lime-800 hover:bg-lime-900 text-white font-bold rounded-lg py-2 px-4 text-sm disabled:opacity-25 disabled:cursor-not-allowed transition-colors"
                disabled={!saveIsActive}
                type="submit"
              >
                Save
              </button>
              <button
                className="bg-red-800 hover:bg-red-900 text-white font-bold rounded-lg py-2 px-4 text-sm disabled:opacity-25 disabled:cursor-not-allowed transition-colors"
                onClick={deleteFeature}
                disabled={!delIsActive}
                type="button"
              >
                Delete
              </button>
              <button
                className="bg-red-800 hover:bg-red-900 text-white font-bold rounded-lg py-2 px-4 text-sm disabled:opacity-25 disabled:cursor-not-allowed transition-colors"
                disabled={!cancelIsActive}
                type="button"
                onClick={cancelButtonHandler}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Upload overlay */}
      <div
        className={`h-screen w-screen fixed top-0 left-0 z-50 flex items-center flex-col justify-center gap-3 ${
          loading ? "" : "hidden"
        }`}
      >
        <div className="h-screen w-screen fixed bg-stone-600 opacity-60" />
        <div className="relative z-10 flex flex-col items-center gap-2">
          <img className="animate-bounce" src={logo40px} alt="" />
          <div className="text-slate-50 font-semibold">
            Uploading ({uploadProgress}%)
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedAdmin;
